<template>
  <div class="ui toogle checkbox custom">
    <input :name="name" type="checkbox" :checked="isChecked(name)" @click="toggleCheckbox($event)">
    <label>
      <div class="facet-element-container">
        <b>{{displayName}}</b>
        <i>{{type}}</i>
        <!--<i>({{count}})</i>-->
      </div>
    </label>
  </div>
</template>

<script>
import store from "../../store/ObservationsStore.js";
import { mapActions, mapGetters } from "vuex";

/**
 * This component diplay a checkbox with the filter name, and the count associated
 */
export default {
  //properties passed by parent component
  props: ["name", "displayName" , "type", "count", "mutationName"],
  computed: {
    /**
     * Vuex store getters
     */
    ...mapGetters(["getFilters", "getFacetClassification", "isFiltersEmpty"])
  },
  methods: {
    /**
     * Vuex store actions
     */
    ...mapActions([
      "initFacets",
      "searchObservations",
      "resetObservations",
      "setBucketFilter"
    ]),
    /**
     * Method triggered when a checkbox is checked.
     * 1 - Update state of the vuex filter store - (async)
     * 2 - when -1- promise is resolved search for new observations using the updated filters
     */
    toggleCheckbox(event) {
      //Vuex filter store action to update query filters
      this.setBucketFilter({
        mutationName: this.mutationName,
        name: this.name
      }).then(() => {
        //If the filters are empty no result are diplayed and the facet are reseted with the whole database
        if (this.isFiltersEmpty) {
          //this.resetObservations();
          //this.initFacets();
        }
        // else, new observation are queried using the updated filters
        else {
          //this.searchObservations(this.getFilters);
        }
      });
    },
    /**
     * Method check the filters that the user previously checked 
     */
    isChecked(id) {
      return (
        this.getFilters.geologies.some(item => item === id) ||
        this.getFilters.climates.some(item => item === id) ||
        this.getFilters.producerNames.some(item => item === id) ||
        this.getFilters.fundingNames.some(item => item === id)
      );
    }
  }
};
</script>

<style>
.custom label {
  float: left;
}

.facet-element-container {
  font-size: 12px;
}
</style>
